import {Spinner} from "reactstrap";

export const LoadingSpinner = () => {
    return (
        <div style={{ textAlign: 'center', justifyItems: 'center' }}>
            <Spinner animation="border" variant="success" />
        </div>
    )
}